import AccordionTab from "components/util/AccordianTab";
import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { allSelectedData } from "../../../redux/slices/allSelectedDataSlice";
import { clearValidationError } from "../../../redux/slices/formValidationSlice";
import { useParams } from "react-router-dom";
import Leasetype from "./Leasetype";

const AmendmentTenant: React.FC<Record<any, any>> = (props) => {

  const dispatch = useAppDispatch();
  const tenant = useAppSelector((state) => state.tenantByPropertyData.data.result);
  const selectedData = useAppSelector((state) => state.allSelectedData);
  const validationErrors = useAppSelector((state) => state.formValidation.errors);
  const {formtype} = useParams();
 

  const handleTenantChangeAmendment = (event: any, newValue: any) => {
    dispatch(allSelectedData({
      ...selectedData,
      standardTenantName: newValue?.standardTenant || '',
      naicS_CodeTenant: newValue?.naiCcode || '',
      unitNumber : newValue?.unitNumber || '', 
      unitSquareFootage : newValue?.unitSquareFootage || '', 
      tenantName : newValue?.tenantName || '',
      tenantId : newValue?.tenantId || '', 
    }));
    
    // Clear validation error when value is selected
    if (newValue) {
      dispatch(clearValidationError('tenantName'));
    }
  }
    const handleUnitNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      dispatch(allSelectedData({
        ...selectedData, 
        unitNumber: value
      }));
      
      if (value) {
        dispatch(clearValidationError('unitNumber'));
      }
    };
    
    const handleUnitSqrFootageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(allSelectedData({
        ...selectedData, 
        unitSquareFootage: event.target.value
      }));  
      
      if (event.target.value) {
        dispatch(clearValidationError('unitSqrFootage'));
      }
    };
  
  
  return (
    <AccordionTab
      title={"AmendmentTenant"} children=
      {
        <div>
          <Grid container spacing={3} >
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Tenant Name</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <Autocomplete
                  id="AmendmentTenant"
                  options={tenant}
                  getOptionLabel={(option) => option.tenantId + ' ' + option.tenantName || ''}
                  value={selectedData.tenantName ?{
                    tenantName : selectedData.tenantName,
                    unitNumber : selectedData.unitNumber,
                    unitSquareFootage : selectedData.unitSquareFootage,
                    standardTenant: selectedData.standardTenantName,
                    naiCcode: selectedData.naicS_CodeTenant,                    
                    tenantId : selectedData.tenantId,                                        
                  } : null}
                  disabled = {formtype === "view" || formtype === "approval"}
                  renderInput={(params) => (
                    <TextField 
                      {...params}
                      
                      placeholder={!selectedData.tenantName ? "Select" : ""}
                      error={!!validationErrors.standardTenants}
                    />
                  )}
                  size="small" 
                  fullWidth={true}
                  onChange={handleTenantChangeAmendment}
                  isOptionEqualToValue={(option: any, value: any) => {
                    return option?.tenantName === value?.tenantName;
                  }}
                />                
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Unit Number</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <TextField 
                  size="small" 
                  fullWidth={true} 
                  inputProps={{
                    min: 0,
                    maxLength: 256,
                    onPaste: (e) => {
                      const pastedText = e.clipboardData.getData('text');
                      if (pastedText.length > 256) {
                        e.preventDefault();
                      }
                    }
                  }}
                  disabled = {formtype === "view" || formtype === "approval"}    
                  onChange={handleUnitNumberChange}                               
                  value={selectedData.unitNumber}
                  error={!!validationErrors.unitNumber}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Unit Square Footage</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <TextField 
                  size="small" 
                  fullWidth={true} 
                  inputProps={{
                    min: 0,
                    maxLength: 256,
                    onPaste: (e) => {
                      const pastedText = e.clipboardData.getData('text');
                      if (pastedText.length > 256) {
                        e.preventDefault();
                      }
                    }
                  }}
                  onChange={handleUnitSqrFootageChange} 
                  disabled = {formtype === "view" || formtype === "approval"}                   
                  value={selectedData.unitSquareFootage}
                  error={!!validationErrors.unitSqrFootage}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>Standard Tenant Name</label><span className="mandatory"> *</span>
              </Grid>
              <Grid>
                <TextField 
                  size="small" 
                  fullWidth={true} 
                  inputProps={{
                    min: 0,
                    maxLength: 256,
                    onPaste: (e) => {
                      const pastedText = e.clipboardData.getData('text');
                      if (pastedText.length > 256) {
                        e.preventDefault();
                      }
                    }
                  }}
                  disabled = {true}                  
                  value={selectedData.standardTenantName}                  
                />                
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid>
                <label>NAICS Code</label>
              </Grid>
              <Grid>
                <TextField size="small" fullWidth={true} inputProps={{
                  min: 0,
                  maxLength: 256,
                }} value={selectedData.naicS_CodeTenant ?? ''} disabled></TextField>
              </Grid>
            </Grid>
            <Grid item xs={0} md={1}></Grid>
            
          </Grid>
        </div>
      } />
  )
}

export default AmendmentTenant;
